
import { IUser } from '../components/user_context_provider';
import { IEppoExperimentArgs } from '../user_hooks';
import { IEppoClient } from './eppoClientContext';

export enum EppoExperimentValues {
  Treatment = 'treatment',
  Control = 'control',
  Fallback = 'fallback',
}

export enum EppoSubjectTypes {
  CLIENT_CONTEXT_ID = 'client_context_id',
  USER_ID = 'user_id',
  SELLER_ID = 'seller_id',
}

export const EPPO_PLATFORM = 'web';
interface IGetEppoAssignment extends IEppoExperimentArgs {
  eppoClient: IEppoClient;
  user: Partial<IUser>;
}

export function getEppoAssignment({
  eppoClient,
  user,
  flagKey,
  subjectKey,
  subjectType,
}: IGetEppoAssignment): string {
  const {
    shippingRegionCode,
    isAdmin,
    email,
    isBot,
  } = user;

  const expSubjectKey = subjectKey ?? user.cookieId;
  const expSubjectType = subjectType ?? EppoSubjectTypes.CLIENT_CONTEXT_ID;

  return eppoClient.getStringAssignment(
    flagKey,
    expSubjectKey,
    {
      subject_type: expSubjectType,
      ra: !!isAdmin,
      shipping_region: shippingRegionCode,
      email,
      is_bot: isBot,
      platform: EPPO_PLATFORM,
    },
    EppoExperimentValues.Fallback,
  );
}

export function isEppoExpEnabled({
  eppoClient,
  user,
  flagKey,
  subjectKey,
  subjectType,
}: IGetEppoAssignment): boolean {
  return getEppoAssignment({
    eppoClient,
    user,
    flagKey,
    subjectKey,
    subjectType,
  }) === EppoExperimentValues.Treatment;
}
